<div class="admin-wrapper">
  <section class="hero card-glass">
    <div class="crumb">
      <span class="crumb-current">Administration</span>
    </div>

    <div class="hero-grid">
      <div class="hero-main">
        <p class="eyebrow">Spay · Console admin</p>
        <h1>Centre de controle administrateur</h1>
        <p class="lead">
          Une vue centralisee pour piloter partenaires, comptes, ledger, depots banque, facturation et fiscalite.
        </p>

        <div class="kpi-grid">
          <article class="kpi-card" *ngFor="let kpi of kpis; trackBy: trackKpi">
            <p class="kpi-label">{{ kpi.label }}</p>
            <p class="kpi-value">{{ kpi.value }}</p>
            <p class="kpi-hint">{{ kpi.hint }}</p>
          </article>
        </div>

        <div class="pill-row">
          <span class="pill" *ngFor="let item of focusItems">{{ item }}</span>
        </div>
      </div>
    </div>
  </section>

  <section class="dashboard-layout">
    <aside class="quick-column">
      <div class="side-card card-glass sticky-card">
        <p class="side-title">Actions rapides</p>
        <p class="side-subtitle">Acces direct aux actions les plus frequentes.</p>

        <div class="quick-grid">
          <a
            *ngFor="let action of quickActions; trackBy: trackAction"
            class="btn btn-pill"
            [ngClass]="{
              'btn-primary': action.tone === 'primary',
              'btn-ghost': action.tone === 'ghost',
              'btn-light': action.tone === 'light'
            }"
            [routerLink]="action.route"
          >
            {{ action.label }}
          </a>
        </div>
      </div>
    </aside>

    <div class="modules-grid">
      <article
        class="module-card card-glass"
        *ngFor="let section of sections; trackBy: trackSection"
        [class.module-accent]="section.accent"
        [class.module-wide]="section.key === 'ledger'"
      >
        <header class="module-head">
          <span class="pill" [class.pill-strong]="section.accent">{{ section.badge }}</span>
          <h3>{{ section.title }}</h3>
          <p>{{ section.description }}</p>
        </header>

        <div class="module-actions">
          <a
            *ngFor="let action of section.actions; trackBy: trackAction; let first = first"
            class="btn btn-pill"
            [class.btn-featured]="first"
            [ngClass]="{
              'btn-primary': action.tone === 'primary',
              'btn-ghost': action.tone === 'ghost' || !action.tone,
              'btn-light': action.tone === 'light'
            }"
            [routerLink]="action.route"
          >
            {{ action.label }}
          </a>
        </div>
      </article>
    </div>
  </section>
</div>
